export const normalizeCount = (count?: number) => {
  if (count === undefined) {
    return 1;
  }

  if (!Number.isFinite(count)) {
    return 0;
  }

  return Math.max(0, Math.floor(count));
};

export const createMultiple = async <T>(
  count: number,
  createOne: () => Promise<T>,
) => {
  const safeCount = normalizeCount(count);

  if (safeCount === 0) {
    return [];
  }

  const requests = Array.from({ length: safeCount }, () => createOne());
  return Promise.all(requests);
};
